import { cmsCLient } from '@/services/axiosConfig'
import { GetCutOver } from './types'

export const getCutOver: GetCutOver = async () => {
  try {
    return (await cmsCLient.get('/cut-over')).data
  } catch (e: any) {
    console.error('Failed to fetch cut-over flags:', e.message)
    return undefined
  }
}
